import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
import Viewer from 'viewerjs';
import "viewerjs/dist/viewer.css";
import './index.less';
const RichText = (props) => {
    const { data } = props;
    const dataSet = data || '';
    const dataCopy = dataSet.replaceAll('<img', '<img class="view-img"');
    useEffect(() => {
        const imgList = document.querySelectorAll('.view-img');
        const index = 1;
        imgList.forEach((imgItem) => {
            const viewer = new Viewer(imgItem, {
                // 0: 不显示
                // 1：显示
                // 2：width>768px
                // 3: width>992px
                // 4: width>1200px
                toolbar: {
                    zoomIn: index,
                    zoomOut: index,
                    oneToOne: index,
                    reset: index,
                    prev: index,
                    play: {
                        show: 1,
                        size: 'small'
                    },
                    next: index,
                    rotateLeft: index,
                    rotateRight: index,
                    flipHorizontal: index,
                    flipVertical: index
                },
                viewed() {
                    viewer.zoomTo(1);
                }
            });
        });
    }, [dataSet]);
    return (_jsx("div", { className: 'rich_htui', dangerouslySetInnerHTML: { __html: dataCopy } }));
};
export default RichText;
//# sourceMappingURL=index.js.map